import React, { FC, memo, useMemo } from 'react';
import MenuItem from '@components/ActionsMenu/MenuItem';
import { RelatedNode } from '@components/MainStage/ContextMenu/RelationshipsMenu/constants/types';
import useOpenRelation from '@components/MainStage/ContextMenu/RelationshipsMenu/hooks/useOpenRelation';
import { TypographyWithElipsis } from '@components/TypographyElipsis';
import { Stack } from '@mui/material';
import { NodeDTOTypes } from '@store/services/nodes/types';
import { getInitiativeNodeIcon, getNodeIcon } from '@utils/canvasIconHelpers';

type Props = {
  search?: string;
  currentId: string;
  nodes: RelatedNode[];
  onCloseMenu: () => void;
};

const NodesList: FC<Props> = ({ search, currentId, nodes, onCloseMenu }) => {
  const { handleOpenRelation } = useOpenRelation();

  const filteredNodes = useMemo(() => {
    return nodes.filter(({ name }) =>
      name.toLowerCase().includes(search?.trim().toLowerCase() || ''),
    );
  }, [search, nodes]);

  return (
    <>
      {filteredNodes.map(({ id, name, type, initiativeType }) => (
        <MenuItem
          key={id}
          item={{
            text: <TypographyWithElipsis>{name}</TypographyWithElipsis>,
            onClick: () => {
              handleOpenRelation(currentId, id);
              onCloseMenu();
            },
            icon: (
              <Stack alignItems="center">
                {type === NodeDTOTypes.Initiatives
                  ? getInitiativeNodeIcon({
                      type: initiativeType!,
                      width: '24px',
                      height: '24px',
                    })
                  : getNodeIcon({
                      type,
                      width: '24px',
                      height: '24px',
                    })}
              </Stack>
            ),
          }}
        />
      ))}
    </>
  );
};

export default memo(NodesList);
